import AppointmentSummary from './AppointmentSummary'

export default AppointmentSummary
